module.exports = __webpack_public_path__ + "static/media/gimli.1b6c9982.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/gimli.png
// module id = 1842
// module chunks = 147